import { DroitApplicatifDto } from '../../data-access/dto/droit-applicatif.dto'
import { DroitApplicatif } from '../../models/droit-applicatif'
import { parseDateServerToDateObject } from '../../utils/date-utils'


export class DroitApplicatifMapper {
  static dtoToModel(droitApplicatifDto: DroitApplicatifDto): DroitApplicatif {
    {
      if (!droitApplicatifDto) {
        return null
      }

      return {
        ...droitApplicatifDto,
        profilsAssocies: droitApplicatifDto.profilsAssocies || [], // <-- On passe la liste directement
        dateCreation: parseDateServerToDateObject(droitApplicatifDto.dateCreation),
        dateModification: parseDateServerToDateObject(droitApplicatifDto.dateModification),
        isNew: droitApplicatifDto.isNew ?? false,
      }
    }
  }
  static dtosToModel(applicationsDto: DroitApplicatifDto[]): DroitApplicatif[] {
    return applicationsDto.map(DroitApplicatifMapper.dtoToModel)
  }
}
